import type React from "react"

export const BLXAppIcon = (props: React.ComponentProps<"svg">): JSX.Element => (
    <svg
        width='30'
        height='30'
        viewBox='0 0 30 30'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <g clipPath='url(#clip0_6260_2290)'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM15.0556 6.97642C18.2103 6.97642 20.8446 7.5312 21.5038 8.27272H21.503V8.6345C21.503 8.72983 21.472 8.83453 21.4208 8.94471C20.6492 7.66481 18.0947 6.97642 15.0556 6.97642ZM8.89811 22.4586C8.71432 22.6993 8.6073 22.9212 8.6073 23.1197V23.4791C9.20055 24.1503 11.4084 24.6684 14.1599 24.7622C11.0253 24.6512 9.54643 23.5268 8.89811 22.4586ZM9.03537 5.22222C9.7341 8.62903 12.1265 11.6162 14.7376 14.194C14.4134 14.437 14.0994 14.6808 13.8039 14.923L13.67 15.0331L13.6695 15.0335L13.6684 15.0344C13.3454 15.2999 13.0308 15.5585 12.7252 15.8122C10.0148 12.5578 9.03537 8.51964 9.03537 5.22222ZM15.4611 18.4166C16.7067 19.4027 17.9935 20.2509 19.07 20.9606C19.8676 21.4863 20.5498 21.936 21.0145 22.3094C21.4743 21.5937 21.5038 20.9842 21.5038 20.9693V20.5122C21.1364 19.9032 20.15 19.0503 18.7883 17.8728C18.3854 17.5245 17.9497 17.1477 17.4875 16.7405L17.4844 16.7421C16.5034 17.6625 15.4759 18.4056 15.4759 18.4056L15.4611 18.4166ZM21.6667 23.1197C21.6667 24.0347 18.7066 24.7778 15.0556 24.7778C20.6298 24.7778 21.6667 21.8851 21.6667 20.9686V23.1197ZM14.1583 24.7622C14.1583 24.7622 14.6686 24.7786 15.0556 24.7778C15.0556 24.7778 14.6655 24.7778 14.1583 24.7622ZM21.6667 10.7856C21.6667 12.2124 18.6663 14.6832 15.7225 17.1031C14.6552 17.9807 13.4299 18.8129 12.2927 19.5853C10.2224 20.9914 8.44444 22.199 8.44444 23.1205V20.9693C8.44444 19.5418 10.8966 17.525 13.907 15.0504C14.9203 14.2172 16.1553 13.3666 17.3393 12.5511C19.5954 10.9973 21.6667 9.57072 21.6667 8.6345V10.7856Z'
                fill='url(#paint0_linear_6260_2290)'
            />
        </g>
        <defs>
            <linearGradient
                id='paint0_linear_6260_2290'
                x1='30'
                y1='30'
                x2='5.84184'
                y2='-4.13447'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#0074E0' />
                <stop offset='1' stopColor='#8BC115' />
            </linearGradient>
            <clipPath id='clip0_6260_2290'>
                <rect width='30' height='30' fill='white' />
            </clipPath>
        </defs>
    </svg>
)
